import { TextField } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import type { ChangeEvent } from 'react';
import { Fragment } from 'react';
import { z } from 'zod';

import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { ParkAndRideFacilitiesTable } from '@/components/management/table/ParkAndRideFacilitiesTable';
import { backendApiParkAndRideFacilitiesFindAllOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

const zValidateSearch = z.object({
  search: z.string().optional(),
  organizationId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/management/stationless/')({
  validateSearch: zValidateSearch,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: StationlessRoute,
  beforeLoad: () => ({ breadcrumb: null }),
});

function StationlessRoute() {
  const { search, organizationId } = Route.useSearch();
  const navigate = Route.useNavigate();

  const { data: facilities } = useQuery(
    backendApiParkAndRideFacilitiesFindAllOptions({ query: { stationless: true, search: search ?? undefined } }),
  );

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    navigate({
      replace: true,
      search: (prev) => ({ ...prev, search: value }),
    });
  };

  return (
    <Fragment>
      <AdministrationHeader
        label="Sonstige Parkraumangebote"
        links={[{ name: 'Parkraumangebot hinzufügen', options: { to: '/management/stationless/create' } }]}
        organizationId={organizationId}
        search={search}
      />
      <AdministrationBody>
        <TextField label="Name" onChange={handleSearchChange} sx={{ width: 256 }} value={search ?? ''} />
        {facilities ? <ParkAndRideFacilitiesTable facilities={facilities} title="Übersicht" /> : null}
      </AdministrationBody>
    </Fragment>
  );
}
